import React from "react";
import { Button } from "./ui/button";

const YachtCollectionSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="order-2 lg:order-1">
            <div className="relative overflow-hidden">
              <img
                src="/images/journey/1_journey_lifetime.jpeg" // Using placeholder for now - would use yacht image
                alt="The Ritz-Carlton Yacht Collection"
                className="w-full h-[500px] object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div>
              <h2 
                className="text-gray-900 mb-4"
                style={{
                  fontFamily: 'Caslon540Std, serif',
                  fontSize: '2.5rem',
                  lineHeight: '3rem',
                  fontWeight: '400',
                  fontStyle: 'italic'
                }}
              >
                The Ritz-Carlton Yacht Collection
              </h2>
            </div>

            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                The intimate yachts of The Ritz-Carlton Yacht Collection fuse the residential feel and legendary service of The Ritz-Carlton with untethered freedom.
              </p>
              
              <Button
                className="bg-transparent border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-3 text-sm font-medium transition-colors duration-200 rounded-none"
                style={{ 
                  fontFamily: 'Swiss-721, Arial, sans-serif',
                  fontSize: '0.8125rem',
                  fontWeight: 700,
                  letterSpacing: '0.5px'
                }}
              >
                Find Your Voyage
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YachtCollectionSection;

